import { startCartFeedback, finishCartFeedback } from './sl-cart-feedback.js';
import { CartAddEvent } from '@theme/events';

(() => {
  if (window.slProductAddonsReady) return;
  window.slProductAddonsReady = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[data-sl-addons]')) return;
    if (form.dataset.slAdding === 'true') { event.preventDefault(); return; }
    const selected = Array.from(form.querySelectorAll('[data-sl-addon]:checked:not(:disabled)'));
    event.preventDefault();
    const data = new FormData(form);
    const id = Number(data.get('id'));
    const quantity = Number(data.get('quantity') || 1);
    if (!id || !Number.isInteger(quantity) || quantity < 1 || !form.reportValidity()) return;
    const properties = {};
    for (const [key, value] of data) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }
    const main = { id, quantity, properties };
    if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
    const items = [main, ...selected.map(input => ({id: Number(input.value), quantity: 1}))];
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-sl-addons-error]');
    if (!startCartFeedback(form)) return;
    let accepted = false;
    form.dataset.slAdding = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    error.hidden = true;
    const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component'))
      .map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
    try {
      const response = await fetch(form.action.replace(/\/?$/, '.js'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items, sections, sections_url: window.location.pathname})
      });
      const result = await response.json();
      if (!response.ok) { finishCartFeedback(form, 'error', result.description || result.message); return; }
      accepted = true;
      finishCartFeedback(form, 'success');
      form.dispatchEvent(new CartAddEvent({}, form.id, {
        source: 'product-form-component',
        itemCount: items.reduce((total, item) => total + item.quantity, 0),
        sections: result.sections
      }));
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.assign(form.action.replace(/\/add\/?$/, ''));
      }
    } catch {
      finishCartFeedback(form, accepted ? 'success' : 'uncertain');
    } finally {
      delete form.dataset.slAdding;
      form.removeAttribute('aria-busy');
    }
  });
})();

